import { render } from "./ddFaceUploader.vue?vue&type=template&id=04f1f794&scoped=true"
import script from "./ddFaceUploader.vue?vue&type=script&lang=js"
export * from "./ddFaceUploader.vue?vue&type=script&lang=js"

import "./ddFaceUploader.vue?vue&type=style&index=0&id=04f1f794&lang=less&scoped=true"

import exportComponent from "/Users/yiduolanghua/Desktop/edu/visitor-h5-jy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04f1f794"]])

export default __exports__